<template>
  <div class="index">
    <div class="line">
      <el-alert
        v-if="retrieve.results.length === 0"
        title="暂无数据"
        type="success"
        :closable="false"
      />
      <div
        v-for="(item, index) in retrieve.results"
        :key="index"
        :class="[(index + 1) % 5 ? 'item' : 'item item-last']"
        @click="click(item.id,item.dataFrom)"
      >
        <img
          :src="util.getImageUrl(util.getHead(util.string2Array(item.images)), '120x120')"
          alt
        >
        <div class="name">
          {{ item.name }}
        </div>
        <div class="features">
          {{ item.features }}
        </div>
      </div>
    </div>
    <el-pagination
      background
      layout="prev, pager, next"
      :total="retrieve.page.totalCount"
      :page-size="retrieve.page.numPerPage"
      :current-page="retrieve.page.pageNum"
      @current-change="onCurrentChange"
    />
  </div>
</template>

<script>
export default {
  name: 'ProductBasePage',
  computed: {
    retrieve() {
      return this.$store.state.product.productBase.retrieve
    }
  },
  methods: {
    onCurrentChange(e) {
      this.$emit('change', e)
    },
    click(id, dataFrom) {
      // 食百百科
      if (dataFrom === 'ProductFoodWiki') {
        window.open(`/product/foodBestInfo/${id}`)
      } else {  // 非食百百科
        window.open(`/product/baike/${id}`)
      }
    }
  }
}
</script>

<style lang="less" scoped>
.index {
  width: 100%;
  .line {
    .item {
      display: inline-block;

      text-align: center;

      width: 140px;
      height: 208px;

      margin-right: 40px;
      margin-bottom: 20px;

      cursor: pointer;

      img {
        border-radius: 10px;
        // box-shadow: 0px 9px 18px 0px rgba(0, 0, 0, 0.06);
        width: 120px;
        height: 120px;
      }

      .name {
        margin: 5px 0;
        height: 40px;
        font-size: 14px;
        font-weight: 600;
        color: rgba(51, 51, 51, 1);
        line-height: 20px;
        display: -webkit-box;
        -webkit-box-orient: vertical;
        -webkit-line-clamp: 2;
        overflow: hidden;

        text-align: center;
      }

      .features {
        font-size: 12px;
        font-weight: 400;
        color: rgba(109, 114, 120, 1);
        line-height: 17px;

        overflow: hidden;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-box-orient: vertical;
        -webkit-line-clamp: 2;
        height: 34px;
      }
    }
    .mr50{
      margin-right: 50px;
    }
    .item-last {
      margin-right: 0;
    }
  }

  .page {
    .prev,
    .next {
      display: inline-block;
      margin: 0 5px;
      cursor: pointer;
    }

    .num {
      border: 1px solid #ccc;
      display: inline-block;
      margin: 0 5px;
      padding: 0 5px;
      cursor: pointer;
    }
    .active {
      color: red;
    }
  }

  .el-pagination {
    text-align: center;
    margin: 20px 0;
  }
  .el-pagination.is-background .el-pager li:not(.disabled).active {
    background-color: #1b994f;
    border-color: #1b994f;
  }
}
</style>
